import { Controller } from "@hotwired/stimulus"

// "Load a preset" dropdown on the music-theory-short Progression step. Each
// option carries the full progression as data-progression JSON; selecting one
// fills title/subtitle/key/bpm and the chord rows, then fires `input` on each
// so the live preview refreshes. The fields stay fully editable — a preset is
// a starting point, not a lock.
export default class extends Controller {
  static targets = ["title", "subtitle", "musicKey", "bpm", "presetSelect", "panelSelect"]

  // Presets carry data-panels ("keyboard,guitar"); when the instrument panel
  // changes, hide the ones that don't suit it (extended-colour progressions
  // are keyboard idiom). A selection that becomes irrelevant resets to the
  // placeholder — the typed chords are untouched.
  filterPresets() {
    if (!this.hasPresetSelectTarget || !this.hasPanelSelectTarget) return
    const panel = this.panelSelectTarget.value
    for (const option of this.presetSelectTarget.options) {
      if (!option.dataset.panels) continue
      option.hidden = !option.dataset.panels.split(",").includes(panel)
      if (option.hidden && option.selected) this.presetSelectTarget.value = ""
    }
  }

  apply(event) {
    const option = event.target.selectedOptions && event.target.selectedOptions[0]
    if (!option || !option.dataset.progression) return

    let preset
    try {
      preset = JSON.parse(option.dataset.progression)
    } catch (_error) {
      return
    }

    this.fill(this.hasTitleTarget && this.titleTarget, preset.title)
    this.fill(this.hasSubtitleTarget && this.subtitleTarget, preset.subtitle)
    this.fill(this.hasMusicKeyTarget && this.musicKeyTarget, preset.key)
    this.fill(this.hasBpmTarget && this.bpmTarget, preset.bpm)
    this.fillChordRows(Array.isArray(preset.chords) ? preset.chords : [])
  }

  fillChordRows(chords) {
    const symbols = this.element.querySelectorAll('input[name$="[chords][][symbol]"]')
    const beats = this.element.querySelectorAll('input[name$="[chords][][beats]"]')
    symbols.forEach((input, i) => this.fill(input, chords[i] ? chords[i].symbol : "", { allowBlank: true }))
    beats.forEach((input, i) => this.fill(input, chords[i] ? chords[i].beats : 4))
  }

  fill(input, value, { allowBlank = false } = {}) {
    if (!input) return
    if ((value === undefined || value === null || value === "") && !allowBlank) return
    input.value = value === undefined || value === null ? "" : value
    input.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
